module.exports = __webpack_public_path__ + "static/media/rooney-mara-icon.8a003c22.jpg";